export default __webpack_public_path__ + "static/media/notFound.40ea4f6a.png";